import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-back",
  "use": "icon-back-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-back\"><path d=\"M627.479 283.894H451.324V137.536l-385.13 196.73 385.13 196.68V384.639H641.56c150.323 0 225.485 64.75 225.485 194.3 0 134.36-77.542 199.111-234.856 199.111H190.636v103.174h448.592c211.356 0 319.389-98.365 319.389-292.666 0-203.919-110.362-304.664-331.138-304.664z\" p-id=\"9490\" fill=\"#FFFFFF\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol